import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';
import { DriveItemInfo } from '../../DriveItemList/reducer';
import ContextualMenuItem from '../../../components/ContextualMenu/Item/Container';

const mapStateToProps = (state: StoreState) => {
	const {
		driveList,
		galleryInfos: { config: { clientId } },
	} = state;
	const { contextualMenu } = driveList;

	let driveItem: DriveItemInfo | undefined;
	let isTemplate = false;

	if (contextualMenu.isOpened) {
		const { driveItems, customTemplates: { ids } } = driveList;
		const { driveItemId } = contextualMenu;

		driveItem = driveItems[driveItemId];
		isTemplate = ids.includes(driveItemId);
	}

	return {
		driveItem,
		clientId,
		isTemplate,
	};
};

export default connect(mapStateToProps)(ContextualMenuItem);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ContextualMenu/Item/index.tsx